import { BaseScene } from '@scarybeasties/phaser-framework-core/scenes';
import { assetsToPreload } from '../assets-to-load';
import { SceneId, TransitionPoint } from '../app-routing';

export default class Boot extends BaseScene {
  constructor() {
    super('Boot');
  }

  preload() {
    let nextScene = this.app.App.getNextSceneFromTransitionPoint(TransitionPoint.BootEnd);
    nextScene = this.app.App.checkForSceneReplacement(nextScene);

    super.preload();
    assetsToPreload(this, nextScene as keyof typeof SceneId);
  }

  create() {
    super.create();
    console.log(__IS_PRODUCTION__);

    if (!__IS_PRODUCTION__) this.scene.launch(SceneId.DebugUI, { test: 'test' });
    this.app.App.gotoNextScene(this, TransitionPoint.BootEnd, { test: 'test' });
  }
}
